const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        label: '협의일',
        value: 'date',
        query: {'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: {sd: '', ed: ''},
        }
      },
      {'component': 'search-disaster-types', label: '재해형태', value: 'disaster', query: {'dty': 'disaster'}, options: {}},
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['부서명', '재해형태', '협의일']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  협의일
    if (search.date) {
      conditions.push({key: 'body.inputA_2', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'body.inputA_2', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  재해형태
    if (search.disaster) {
      // riskAppraisalList 으로 검색 되도록 수정해야함
      conditions.push({key: 'body.inputB_1', operator: 'LIKE', value: `%${search.disaster}%`})
    }

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "부서명",
        "key": "field.com_name",
        "sortKey": false
      },
      {
        "name": "팀명",
        "key": "field.team_company_list[%].com_name",
        "sortKey": false
      },
      {
        "name": "사업장명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "협의일",
        "key": "body.inputA_2"
      },
      {
        "name": "재해형태",
        "key": "body.inputB_1"
      },
      {
        "name": "소속명",
        "key": "body.stdInfo.department"
      },
      {
        "name": "작성자",
        "key": "body.stdInfo.writer_name"
      }
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: {
          const meta = JSON.parse(value.field.meta || '{}')
          return func.getContent(value).stdInfo.부서명_과 || meta.com_name // 부서명_과
        }
        case 1: {
          const team_company_list = JSON.parse(value.field.meta || '{}').team_company_list;
          return team_company_list ? team_company_list.map(team => team.com_name).join(', ') : '-';
        }
        case 2: return func.getContent(value).stdInfo.field_name // 사업장명
        case 3: return func.getContent(value).inputA_2 // 협의일
        case 4: return func.getContent(value).inputB_1 // 재해형태
        case 5: return func.getContent(value).stdInfo.department // 소속명
        case 6: return func.getContent(value).stdInfo.writer_name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
